import { Grid, makeStyles, Typography } from '@material-ui/core'
import { FC, useState, useEffect } from 'react'
import UploadImage from '../../../control/uploadImage/uploadImage'
import useTranslate from '../../../i18n/useTranslate'
import useWebService from '../../../services/web/useWebService'
import useAuthenStore from '../../../stores/authen/authenStore'
import { LanguageType, CertificateFormProps } from '../../../pages/SettingCertificate'
import { convertPathToNameImg } from '../../../utilities/pathImg'
interface UploadLogoProps {
    form: any
    initialValues?: CertificateFormProps
}
const UploadLogo: FC<UploadLogoProps> = ({ form, initialValues }) => {
    const translate = useTranslate()
    const classes = usestyles()

    const callWebService = useWebService()

    const [temp, setTemp] = useState<{
        imgUpload_th: string | null
        imgUpload_en: string | null
        name_th: string | null | undefined
        name_en: string | null | undefined
    }>({
        imgUpload_th: null,
        imgUpload_en: null,
        name_th: null,
        name_en: null,
    })

    useEffect(() => {
        setTemp({
            imgUpload_th: initialValues?.imgUpload_th || null,
            imgUpload_en: initialValues?.imgUpload_en || null,
            name_th: initialValues?.imgUpload_th ? convertPathToNameImg(initialValues?.imgUpload_th) : null,
            name_en: initialValues?.imgUpload_en ? convertPathToNameImg(initialValues?.imgUpload_en) : null,
        })
    }, [initialValues])

    const onUpload = async (event: React.ChangeEvent<HTMLInputElement>, language: LanguageType) => {
        const file = event.target.files?.[0]
        const formDataImage = new FormData()
        if (file) {
            formDataImage.append('files', file)

            const { result } = await callWebService.uploadFileTemp(formDataImage)

            if (result.length > 0) {
                if (language === 'th') {
                    setTemp({ ...temp, imgUpload_th: result[0].path, name_th: result[0].filename })
                    form.change('imgUpload_th', result)
                } else {
                    setTemp({ ...temp, imgUpload_en: result[0].path, name_en: result[0].filename })
                    form.change('imgUpload_en', result)
                }
            }
        }
    }

    return (
        <Grid container justify="center" className={classes.container} spacing={2}>
            <Grid item xs={12} md={6} lg={6}>
                <Typography>{translate.get('UM.UPLOAD.LOGO_TH')}</Typography>
                <img
                    src={temp.imgUpload_th ? `${temp.imgUpload_th}` : `${process.env.PUBLIC_URL}/img/default.jpg`}
                    id="profile"
                    alt=""
                    width="300"
                    height="230"
                    className={classes.image}
                />
                <Grid container alignItems="center" direction="row">
                    <Grid item xs={12} md={6} lg={8} style={{ textAlign: 'center', wordBreak: 'break-word' }}>
                        <Typography>{temp.name_th ? temp.name_th : ''}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4} style={{ textAlign: 'end' }}>
                        <UploadImage
                            name="imgUpload_th"
                            onChange={(event) => onUpload(event, 'th')}
                            color={'primary'}
                            labelTitle={translate.get('BUTTON.UPLOAD')}
                        />
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                <Typography>{translate.get('UM.UPLOAD.LOGO_EN')}</Typography>
                <img
                    src={temp.imgUpload_en ? `${temp.imgUpload_en}` : `${process.env.PUBLIC_URL}/img/default.jpg`}
                    id="profile"
                    alt=""
                    width="300"
                    height="230"
                    className={classes.image}
                />
                <Grid container alignItems="center" direction="row">
                    <Grid item xs={12} md={6} lg={8} style={{ textAlign: 'center', wordBreak: 'break-word' }}>
                        <Typography>{temp.name_en ? temp.name_en : ''}</Typography>
                    </Grid>
                    <Grid item xs={12} md={6} lg={4} style={{ textAlign: 'end' }}>
                        <UploadImage
                            name="imgUpload_en"
                            onChange={(event) => onUpload(event, 'en')}
                            color={'primary'}
                            labelTitle={translate.get('BUTTON.UPLOAD')}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
export default UploadLogo

const usestyles = makeStyles((theme) => ({
    image: {
        display: 'flex',
        margin: '15px auto',
        width: '330px',
        height: '230px',
        objectFit: 'contain',

        [theme.breakpoints.down('xs')]: {
            width: '260px',
            height: '180px',
        },
    },
    container: {
        padding: '8px 15px',
    },
}))
